<template>
  <div>
    <template v-if="value.event_type == 'create'">
      Job created -
      {{ value.source }} -
      <b-badge variant="primary">{{ value.new_values.job.status }}</b-badge>
    </template>
    <template v-else-if="value.event_type == 'cancellation'">
      Cancellation reason
    </template>
    <template v-else-if="value.event_type == 'cancellation_clone'">
      Job Cloned by Cancellation reason
    </template>
    <template v-else-if="value.event_type == 'new_status'">
      <b-badge>{{ value.old_values.job.status }}</b-badge>
      &gt;
      <b-badge variant="primary">{{ value.new_status }}</b-badge>
    </template>
    <template v-else-if="value.event_type == 'edit'">Values updates</template>
    <template v-else>Other change</template>
    <small class="text-muted" v-if="value.admin && value.admin.sfid">
      by
      <span class="text-body">{{ value.admin.name }}</span>
      (admin)
    </small>
    <small class="text-muted" v-else-if="value.user && value.user.id">
      by
      <span class="text-body">{{ value.user.name }}</span>
      (user)
    </small>
    <b-button
      @click="details = !details"
      size="sm"
      variant="link"
      class="gid-feed__details p-0 align-baseline"
    >
      <small v-if="!details">show details</small>
      <small v-else>hide details</small>
    </b-button>
    <b-collapse v-model="details" class="mt-2">
      <b-card no-body>
        <b-tabs pills small card>
          <b-tab title="Diff" active no-body>
            <b-card-text>
              <vue-json-compare
                :oldData="value.old_values"
                :newData="value.new_values"
              ></vue-json-compare>
            </b-card-text>
          </b-tab>
          <b-tab title="Raw Data">
            <b-card-text>
              <h5>New values</h5>
              <small>
                <pre style="white-space: pre-wrap">{{ value.new_values }}</pre>
              </small>
              <h5>Old values</h5>
              <small>
                <pre style="white-space: pre-wrap">{{ value.old_values }}</pre>
              </small>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>
import axios from 'axios';
import VueJsonCompare from 'vue-json-compare';

export async function fetchLogs({ job: { sfid: jobSfid } }) {
  return await axios
    .get(`/api/admin/jobs/${jobSfid}/log-entries`)
    .then(({ data }) =>
      data.map((value) => ({
        time: new Date(value.time_stamp),
        value,
      })),
    );
}

export default {
  components: {
    VueJsonCompare,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      details: false,
    };
  },
};
</script>
